module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "ctn"
    }
  }, [_c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.ready && !_vm.isMobileData),
      expression: "!ready && !isMobileData"
    }]
  }), _c('div', {
    staticClass: "left-bg"
  }), _c('div', {
    staticClass: "right-bg"
  }), _c('transition', {
    attrs: {
      "name": "background-shape",
      "css": false,
      "mode": "out-in",
      "appear": "appear"
    },
    on: {
      "enter": _vm.shapeEnter
    }
  }, [_c('route-background', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ready),
      expression: "ready"
    }],
    attrs: {
      "transform": _vm.currentBackground
    }
  })], 1), _c('site-nav'), _c('div', {
    staticClass: "wrap"
  }, [(_vm.ready) ? _c('site-header', {
    ref: "header",
    attrs: {
      "indicator": _vm.currentIndicator
    }
  }) : _vm._e(), (_vm.ready) ? _c('route-image', {
    attrs: {
      "image": _vm.currentImage
    }
  }) : _vm._e(), _c('div', {
    staticClass: "view-ctn"
  }, [(_vm.ready) ? _c('transition', {
    attrs: {
      "name": "page",
      "css": false,
      "mode": "out-in",
      "appear": "appear"
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter,
      "leave": _vm.leave
    }
  }, [_c('router-view', {
    ref: "page",
    staticClass: "view"
  })], 1) : _vm._e(), _c('div', {
    staticClass: "clear"
  })], 1), _c('div', {
    staticClass: "clear"
  })], 1), _c('div', {
    staticClass: "clear"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69db3994"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 430
// module chunks = 1